<p-button
  label="Zurück"
  (onClick)="this.chatService.selectedTeilaufgabeTable = undefined"
></p-button>

<p-toast></p-toast>

<h3>
  Aufgabe {{this.selectedAufgabe?.aufgabenIndex}}.{{this.selectedTeilaufgabe.teilaufgabenIndex}}
</h3>
<span
  [innerHTML]="this.selectedTeilaufgabe.aufgabenstellung"
  (copy)="this.onQuestionCopy()"
></span>
<p-table
  [value]="this.selectedTeilaufgabe.table"
  class="mt-3"
  showGridlines
>
  <ng-template
    #body
    let-entry
    let-ri="rowIndex"
  >
    <tr>
      @for (col of entry; track $index) {
      @if(col.isEditable){
      <td
        [pEditableColumn]="col.solution"
        pEditableColumnField="solution"
        [width]="100 / entry.length + '%'"
        [ngStyle]="{'border-top-width': (ri == 0 ? '1px' : '0')}"
        class="relative"
        style="text-align: center !important;"
      >
        <p-cellEditor>
          <ng-template #input>
            <textarea
              pTextarea
              [(ngModel)]="col.solution"
              [ngModelOptions]="{updateOn: 'blur'}"
              (ngModelChange)="this.saveAnswer(ri, $index, $event)"
              rows="1"
              cols="10"
              fluid
              (keydown)="this.onKeyEnter(ri, $index, editTextarea.value, $event)"
              (paste)="this.onTablePaste($event)"
              #editTextarea
            ></textarea>
          </ng-template>
          <ng-template #output>
            {{ col.solution }}
            <i
              class="pi pi-pencil absolute top-1 right-1"
              style="font-size: 7pt;"
            ></i>
          </ng-template>
        </p-cellEditor>
      </td>
      }@else{
      @if(col.isHeader){
      <td
        [ngStyle]="{'border-top-width': (ri == 0 ? '1px' : '0')}"
        class="bg-gray-100"
        style="text-align: center !important;"
      >
        <b class="whitespace-pre">{{col.value}}</b>
      </td>
      }@else{
      <td
        [ngStyle]="{'border-top-width': (ri == 0 ? '1px' : '0')}"
        style="text-align: center !important;"
      >
        {{col.value}}
      </td>
      }
      }
      }
    </tr>
  </ng-template>
</p-table>